import GoalSurveyType from "@/api/dataSource/api/Spirit/Entities/User/GoalSurveyType";
/** Модель статистики использования приложения */
export default class GoalSurveyModel {
    constructor(obj?: GoalSurveyModel) {
        if (obj) Object.assign(this, obj);
    }
    /** Цель использования приложения */
    Id: GoalSurveyType = null;
    /** Процент использования приложения */
    UsagePercentage: number | string = null;
}